import React, { useState, useEffect } from 'react';
import apiClient from '../../../api/apiClient';
import { subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { Table, Form, InputGroup, Container, Row, Col, Pagination, Button } from 'react-bootstrap';
import { PopupModel, AlertMassage } from '../../shared';
import { getTags, formatDate, downloadFile } from '../../../utils/utils';
import { DeleteIcon, DownloadIcon } from '../../../utils/FontIcon';
import { GETREFERENCEDOC } from '../../../utils/ApiEndPoint';

const ResourceList = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false

    })
    const [documents, setDocuments] = useState([]);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: {},
    })
    const pageSize = 10;

    useEffect(() => {
        fetchResource();
    }, []);
    useEffect(() => {
        const pubsubToken = subscribe('FETCH_RESOURCE', () => {
            fetchResource();
        });
        return () => unsubscribe(pubsubToken);
    }, []);
    const fetchResource = () => {
        setLoading(true)
        apiClient.get(GETREFERENCEDOC)
            .then((response) => {
                if (response.status === 200) {
                    setDocuments(response.data);
                } else {
                    setError('Failed to load refrence documents')
                }
            }).catch((error) => {
                setError('Failed to load refrence documents')
            }).finally(() => {
                setLoading(false);
            });
    };
    const handelConfirm = (item) => {
        setPopupData({
            show: true,
            title: 'Confirm Deletion',
            type: 'confirm',
            selectedItem: item,
        })
    }
    const handelDelete = async () => {
        const id = popupData.selectedItem._id;
        const title = popupData.selectedItem.title;
        let tempAlert = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        }
        apiClient.patch(`${GETREFERENCEDOC}/${id}/soft-delete`,)
            .then((response) => {
                if (response.status === 200) {
                    fetchResource();
                    tempAlert.type = 'success';
                    tempAlert.title = 'Success';
                    tempAlert.msg = `${title} is deleted successfully`;
                    setShowAlert(tempAlert)
                } else {
                    tempAlert.msg = `Failed to delete ${title} document`,
                        setShowAlert(tempAlert);
                }
            }).catch((error) => {
                tempAlert.msg = `Failed to delete ${title} document`,
                    setShowAlert(tempAlert);
            }).finally(() => {
                handleCloseModal();
            });
    }
    const handelDownload = (item) => {
        downloadFile(item.documentUrl, item.title)
    }
    const handleCloseModal = () => {
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: {},
        })
    }
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }
    const filteredDocuments = documents.filter(document => {
        const searchLower = search.toLowerCase();
        return (
            document?.title?.toLowerCase().includes(searchLower) ||
            (Array.isArray(document.tags) ? document.tags.join(' ').toLowerCase() : '').includes(searchLower)
        );
    });

    const paginatedVideos = filteredDocuments.slice(
        (currentPage - 1) * pageSize,
        currentPage * pageSize
    );

    const totalPages = Math.ceil(filteredDocuments.length / pageSize);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    if (loading) return <p className='p-2 w-100 text-center m-3 bg-light'>Loading questions...</p>;
    if (error) return <p className='p-2 w-100 text-center m-3 bg-light'>{error}</p>;
    return (
        <Container fluid className="mt-2 px-4">
            <Row className="justify-content-between align-items-center mb-1">
                <Col md={6}>
                    <h6 className='fw-700'>Existing Material List</h6>
                </Col>
                <Col md={4}>
                    <InputGroup>
                        <Form.Control
                            placeholder="Search document..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </InputGroup>
                </Col>
            </Row>
            <Row>
                <Col lg={12}>
                    <Table responsive className='mytable'>
                        <thead >
                            <tr>
                                <th scope="col" className='txt-center'>S.No.</th>
                                <th scope="col" className='text-nowrap'>Title</th>
                                <th scope="col" className='text-nowrap'>Description</th>
                                <th scope="col" className='text-nowrap'>Keywords</th>
                                <th scope="col" className='text-nowrap'>Document Size</th>
                                <th scope="col" className='text-nowrap'>Document Type</th>
                                <th scope="col" className='text-nowrap'>Created at</th>
                                <th scope="col" className='text-nowrap'>Created by</th>
                                <th scope="col" className='text-nowrap'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedVideos.map((document, idx) => {

                                return <tr key={idx + (currentPage - 1) * pageSize}>
                                    <td>
                                        {(currentPage - 1) * pageSize + idx + 1}
                                    </td>
                                    <td>{document.title}</td>
                                    <td>{document.description}</td>
                                    <td>{document.tags && document.tags.length ? getTags(document.tags) : ''}</td>
                                    <td>{document.size ? document.size : ''}</td>
                                    <td>{document.mimeType ? document.mimeType : ''}</td>
                                    <td className='text-nowrap'>{formatDate(document.createdAt)}</td>
                                    <td>{document.createdBy ? document.createdBy : ''}</td>
                                    <td>
                                        <div style={{ display: 'flex', paddingBlock: '1rem' }}>
                                            <a
                                                style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
                                                onClick={(e) => handelDownload(document)}
                                                title={'Download'}>
                                                <DownloadIcon />
                                            </a>
                                            <a
                                                style={{ cursor: 'pointer', marginLeft: '10px', marginRight: '10px' }}
                                                onClick={(e) => handelConfirm(document)}
                                                title={'Delete'}>
                                                <DeleteIcon />
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            }
                            )}
                        </tbody>
                    </Table></Col>
                <Col lg={12}>
                    <div className="d-flex justify-content-center">
                        <Pagination className='mypagination-listing'>
                            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                            {[...Array(totalPages)].map((_, idx) => (
                                <Pagination.Item
                                    key={idx + 1}
                                    active={currentPage === idx + 1}
                                    onClick={() => handlePageChange(idx + 1)}
                                >
                                    {idx + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                        </Pagination>
                    </div>
                </Col>
            </Row>
            <PopupModel
                size='md'
                showModal={popupData.show}
                handleCloseModal={handleCloseModal}
                title={popupData.title}
                type={popupData.type}
                footerContent={
                    <>
                        <Button variant="danger" onClick={handelDelete}>Yes</Button>
                        <Button variant="info" onClick={handleCloseModal}>No</Button>
                    </>
                }
            >
                <p>Are you sure you want to delete <strong>{popupData.selectedItem.title}</strong> ? This action cannot be undone.</p>
            </PopupModel>
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }

        </Container >
    );
};

export default ResourceList;